import { CodeSnippetEnvType, WorkflowCredentialsType } from "../types";
import { HOSTED_CODE } from "./HOSTED_CODE";

export const generateWorkflowCodeSnippet = (
    option: CodeSnippetEnvType,
    workflowCredentials: WorkflowCredentialsType
): string => {
    return HOSTED_CODE({
        endpoint: workflowCredentials.baseUrl,
        workflowName: workflowCredentials.workflowUrl,
        workspaceUrl: workflowCredentials.workspaceUrl,
        apiKey: workflowCredentials.apiKey,
        workflowParameters: [{ name: "image", type: "url", value: "IMAGE_URL" }],
        workflowImages: [{ name: "image", type: "url", value: "IMAGE_URL" }],
        language: option
    }) as string;
};
